import * as React from 'react';
import styled from 'styled-components';

import ReactPlayer from 'react-player';
import phoneOutline from '../images/phone/236x481.png';

import defaultThumbnail from '../images/phone/home.jpg';

const LeafDecoration = styled.div`
	// @media (${(props) => props.theme.smallUp}) {
		background-repeat: no-repeat;
	// }
`;

const PhoneSkin = styled.div`
	background-image: ${(props) => `url('${phoneOutline}')`};
	background-repeat: no-repeat;
	background-position: center top;
	bakground-size: 100% 100%;
	background-size: cover;
	margin: 0 auto;
	box-shadow: ${(props) => props.theme.roundedBoxShadowHeavy};
	display: flex;
	justify-content: center;
	align-iterms: center;
	padding: 20px 4px 30px;
	width: 135px;
	height: 282px;
	border-radius: 20px;
	overflow: hidden;

	@media (${(props) => props.theme.smallUp}) {
		width: 236px;
		height: 481px;
		border-radius: 35px;
		padding: 45px 9px 55px;
	}

	@media (${(props) => props.theme.mediumUp}) {
		width: 200px;
		height: 418px;
		border-radius: 30px;
		padding: 33px 7px 50px;
	}

	@media (${(props) => props.theme.largeUp}) {
		width: 236px;
		height: 481px;
		border-radius: 35px;
		padding: 45px 9px 55px;
	}

	& .videoWrapper {
		display: block;
		overflow: hidden;
		max-width: 127px;
		max-height: 226px; // original is 750x1334

		@media (${(props) => props.theme.smallUp}) {
			max-width: 218px;
			max-height: 388px; // original is 750x1334
		}

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 186px;
			max-height: 331px; // original is 750x1334
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 218px;
			max-height: 388px; // original is 750x1334

		}
	}
`;

const PhonePlayer = (props: any) => {
	let falseOrThumbnail = false;
	if (props.thumbnail) {
		falseOrThumbnail = props.thumbnail;
	}

	return (
		<LeafDecoration className='decorationBehindPhone'>
			<PhoneSkin>
				<ReactPlayer
					className='videoWrapper'
					url={[
						{ src: props.PhoneVideoWEBM, type: 'video/webm' },
						{ src: props.PhoneVideoMP4, type: 'video/mp4' },
					]}
					playing={true}
					loop={true}
					controls={false}
					muted={true}
					height='100%'
					width='100%'
					light={falseOrThumbnail}
					playsinline={true}
				/>
			</PhoneSkin>
		</LeafDecoration>
	);
};

export default PhonePlayer;
